export const USER_ROLES = {
  OWNER: "owner",
  RENTER: "renter",
  AGENT: "agent",
  SALE_AGENT: "sale_agent",
  VIEWING_AGENT: "viewing_agent",
  SALE_VIEWING_AGENT: "sale_viewing_agent",
  SUPER_ADMIN: "super_admin"
};
